import { CommonModule, DatePipe } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { LOCALE_ID, NgModule } from "@angular/core";
import { SimulatorsListComponent } from "./simulators-list/simulators-list.component";
import { PriceBandsListComponent } from "./price-bands-list/price-bands-list.component";
import { PricesListComponent } from "./prices-list/prices-list.component";
import { CalendarModule, MOMENT } from 'angular-calendar';
import { SchedulerModule } from 'angular-calendar-scheduler';
import * as moment from "moment";
import { DateAdapter } from "@angular/material/core";
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ContextMenuComponent } from "./booking-extensions/ui/context-menu.component";
import { SimulatorBookingRoutingModule } from "./simulator-booking-routing.module";
import { PriceCreateModalComponent } from "./modals/price/price-create-modal/price-create-modal.component";
import { PriceBandCreateModalComponent } from "./modals/price-band/price-band-create-modal/price-band-create-modal.component";
import { SimulatorCreateModalComponent } from "./modals/simulator/simulator-create-modal/simulator-create-modal.component";
import { BookingCreateModalComponent } from "./modals/booking/booking-create-modal/booking-create-modal.component";
import { BookingEditModalComponent } from "./modals/booking/booking-edit-modal/booking-edit-modal.component";
import { CreateScheduledBookingModalComponent as ScheduledBookingCreateModalComponent } from "./modals/booking/create-scheduled-booking-modal/create-scheduled-booking-modal.component";
import { EditScheduledBookingModalComponent as ScheduledBookingEditModalComponent } from "./modals/booking/edit-scheduled-booking-modal/edit-scheduled-booking-modal.component";
import { BookingWidgetShellComponent } from "./booking-widget-shell/booking-widget-shell.component";
import { BookingListComponent } from "./booking-list/booking-list.component";
import { ScheduledBookingListComponent } from "./scheduled-booking-list/scheduled-booking-list.component";
import { AddonListComponent } from "./addon-list/addon-list.component";
import { AddonCreateModelComponent } from "./modals/addon/addon-create-model/addon-create-model.component";
import { AddonEditModelComponent } from "./modals/addon/addon-edit-model/addon-edit-model.component";
import { MyAccountComponent } from "./my-account/my-account.component";
import { BookingRefundModalComponent } from "./modals/booking/booking-refund-modal/booking-refund-modal.component";
import { SimulatorEditModalComponent } from "./modals/simulator/simulator-edit-modal/simulator-edit-modal.component";
import { PriceEditModalComponent } from "./modals/price/price-edit-modal/price-edit-modal.component";
import { BookingQuickviewModalComponent } from "./modals/booking/booking-quickview-modal/booking-quickview-modal.component";
import { PromoCodesListComponent } from "./promo-codes-list/promo-codes-list.component";
import { PromoCodeCreateModalComponent } from "./modals/promo-code/promo-code-create-modal/promo-code-create-modal.component";
import { PromoCodeEditModalComponent } from "./modals/promo-code/promo-code-edit-modal/promo-code-edit-modal.component";
import { InvoiceListComponent } from "./my-account/invoice-list/invoice-list.component";
import { PlansComponent } from "./my-account/plans/plans.component";
import { WaiversListComponent } from './digital-waiver/waivers-list/waivers-list.component';
import { EntriesListComponent } from './digital-waiver/entries-list/entries-list.component';
import { WaiverCreateModalComponent } from './modals/waiver/waiver-create-modal/waiver-create-modal.component';
import { WaiverEditModalComponent } from './modals/waiver/waiver-edit-modal/waiver-edit-modal.component';
import { BookingSchedulerV2Component } from "./booking-scheduler-v2/booking-scheduler-v2.component";
import { WaiverEntriesQuickViewComponent } from "./modals/waiver/entries-quick-view/waiver-entries-quick-view.component";
import { WaiverEntryManualCreateModalComponent } from "./modals/waiver/waiver-entry-manually-create-modal/waiver-entry-manual-create-modal.component";
import { MembershipPlanCreateModalComponent } from "./modals/membership/membership-plan-create-modal/membership-plan-create-modal.component";
import { MembershipPlanEditModalComponent } from "./modals/membership/membership-plan-edit-modal/membership-plan-edit-modal.component";
import { MembershipPlansListComponent } from "./memberships/membership-plans-list/membership-plans-list.component";
import { MembershipCustomerListComponent } from "./memberships/membership-customer-list/membership-customer-list.component";
import { MembershipCustomerCreateModalComponent } from "./modals/membership/membership-customer-create-modal/membership-customer-create-modal.component";
import { MembershipCustomerEditModalComponent } from "./modals/membership/membership-customer-edit-modal/membership-customer-edit-modal.component";
import { BookingMembershipWidgetShellComponent } from "./booking-membership-widget-shell/booking-membership-widget-shell.component";
import { MembershipCustomerWidgetShellComponent } from "./membership-customer-widget-shell/membership-customer-widget-shell.component";
import { LeagueListComponent } from "./league-list/league-list.component";
import { CreateLeagueModalComponent } from "./modals/league/create-league-modal/create-league-modal.component";
import { EditLeagueModalComponent } from "./modals/league/edit-league-modal/edit-league-modal.component";
import { CreateLeagueIterationModalComponent } from "./modals/league-iteration/create-league-iteration-modal/create-league-iteration-modal.component";
import { EditLeagueIterationModalComponent } from "./modals/league-iteration/edit-league-iteration-modal/edit-league-iteration-modal.component";
import { CloneLeagueIterationModalComponent } from "./modals/league-iteration/clone-league-iteration-modal/clone-league-iteration-modal.component";
import { LeagueIterationsListComponent } from "./league-iterations-list/league-iterations-list.component";
import { LeagueMembersListComponent } from "./league-members-list/league-members-list.component";
import { CreateLeagueMemberModalComponent } from "./modals/league-member/create-league-member-modal/create-league-member-modal.component";
import { EditLeagueMemberModalComponent } from "./modals/league-member/edit-league-member-modal/edit-league-member-modal.component";
import { AddMembersToIterationModalComponent } from "./modals/league-member/add-members-to-iteration-modal/add-members-to-iteration-modal.component";
import { LeagueIterationMembersListComponent } from "./league-iteration-members-list/league-iteration-members-list.component";
import { BookingSettingsComponent } from "./my-account/booking-settings/booking-settings.component";

export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/DD/YYYY',
    },
    display: {
        dateInput: 'MM/DD/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [
        SimulatorsListComponent,
        PriceBandsListComponent,
        PricesListComponent,
        ContextMenuComponent,
        SimulatorCreateModalComponent,
        SimulatorEditModalComponent,
        PriceBandCreateModalComponent,
        PriceCreateModalComponent,
        BookingCreateModalComponent,
        BookingEditModalComponent,
        ScheduledBookingCreateModalComponent,
        ScheduledBookingEditModalComponent,
        BookingWidgetShellComponent,
        BookingMembershipWidgetShellComponent,
        MembershipCustomerWidgetShellComponent,
        BookingListComponent,
        ScheduledBookingListComponent,
        AddonListComponent,
        AddonCreateModelComponent,
        AddonEditModelComponent,
        MyAccountComponent,
        BookingRefundModalComponent,
        PriceEditModalComponent,
        BookingQuickviewModalComponent,
        PromoCodesListComponent,
        PromoCodeCreateModalComponent,
        PromoCodeEditModalComponent,
        BookingSchedulerV2Component,
        InvoiceListComponent,
        PlansComponent,
        EntriesListComponent,
        WaiverCreateModalComponent,
        WaiverEditModalComponent,
        WaiversListComponent,
        WaiverEntriesQuickViewComponent,
        WaiverEntryManualCreateModalComponent,
        MembershipPlanCreateModalComponent,
        MembershipPlanEditModalComponent,
        MembershipPlansListComponent,
        MembershipCustomerListComponent,
        MembershipCustomerCreateModalComponent,
        MembershipCustomerEditModalComponent,
        LeagueListComponent,
        CreateLeagueModalComponent,
        EditLeagueModalComponent,
        CreateLeagueIterationModalComponent,
        EditLeagueIterationModalComponent,
        CloneLeagueIterationModalComponent,
        LeagueIterationsListComponent,
        LeagueMembersListComponent,
        CreateLeagueMemberModalComponent,
        EditLeagueMemberModalComponent,
        AddMembersToIterationModalComponent,
        LeagueIterationMembersListComponent,
        BookingSettingsComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        SimulatorBookingRoutingModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        SchedulerModule.forRoot({
            locale: 'en',
            headerDateFormat: 'daysRange',
            logEnabled: false,
        })
    ],
    exports: [
        ContextMenuComponent,
        SimulatorCreateModalComponent,
        PriceBandCreateModalComponent,
        PriceCreateModalComponent,
        BookingCreateModalComponent,
        BookingEditModalComponent,
        AddonCreateModelComponent,
        AddonEditModelComponent,
        PromoCodeCreateModalComponent,
        PromoCodeEditModalComponent,
        InvoiceListComponent,
        PlansComponent,
        WaiverCreateModalComponent,
        WaiverEditModalComponent,
        WaiverEntriesQuickViewComponent,
        WaiverEntryManualCreateModalComponent,
        MembershipPlanCreateModalComponent,
        MembershipPlanEditModalComponent,
        MembershipPlansListComponent,
        MembershipCustomerListComponent,
        MembershipCustomerCreateModalComponent,
        MembershipCustomerEditModalComponent,
        ScheduledBookingCreateModalComponent,
        ScheduledBookingEditModalComponent,
        LeagueListComponent,
        CreateLeagueModalComponent,
        EditLeagueModalComponent,
        CreateLeagueIterationModalComponent,
        EditLeagueIterationModalComponent,
        CloneLeagueIterationModalComponent,
        LeagueIterationsListComponent,
        LeagueMembersListComponent,
        CreateLeagueMemberModalComponent,
        EditLeagueMemberModalComponent,
        AddMembersToIterationModalComponent,
        LeagueIterationMembersListComponent,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'en-US' },
        { provide: MOMENT, useFactory: () => moment },
        DatePipe
    ],
})
export class SimulatorBookingModule { }
